import script from "./UsuarioPasswordRecordar.vue?vue&type=script&setup=true&lang=js"
export * from "./UsuarioPasswordRecordar.vue?vue&type=script&setup=true&lang=js"

import "./UsuarioPasswordRecordar.vue?vue&type=style&index=0&id=2e1ce7a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e1ce7a2"]])

export default __exports__